<template>
  <div class="content">
    <h1 class="font-light">Not Authorised</h1>
    <div class="panel">
      <div class="placeholder">
        <div class="placeholder-icon">
          <span class="icon">
            <i class="fa fa-wrapper fa-eye-slash huge-icon"></i>
          </span>
        </div>
        <space></space>
        <h3 class="placeholder-title font-light">
          Sorry, you're not authorised to view that page.
        </h3>
        <div class="placeholder-subtitle">
          Contact the site admin on
          <a href="mailto:admin@taslytic.com">admin@taslytic.com</a> if you
          think you should be able to access it.
        </div>
      </div>
    </div>
  </div>
</template>
<style>
a {
  display: inline;
}
</style>
<script>
export default {
  name: "unauthorised-page"
};
</script>
